import React, {useState, createContext, useContext} from 'react'
import jwt_decode from "jwt-decode";
import moment from 'moment'
export const TeamManagementContext = createContext()

export const TeamManagementProvider = (props) => {
    const [isTeamPresent, setisTeamPresent] = useState(true)
    const [agentListView, setAgentListView] = useState(false)
    const loggedInUserRole = localStorage && localStorage.authToken && jwt_decode(localStorage.authToken).auth
    const loggedInUserName = localStorage.userName
    const [teamSelected, setTeamSelected] = useState('')
    const [isMarkException, setMarkException] = useState(false)
    const [agentsData, setAgentsData] = useState([])
    const [showAddAgent, setShowAddAgent] = useState(false)
    const [agentsSelectedForMarking, setAgentsSelectedForMarking] = useState([])
    const [isDateRangeExceeded, setIsDateRangeExceeded] = useState(false)
    const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"))
    const [showAttendanceCriteriaPanel, setShowAttendanceCriteriaPanel] = useState(false)
    const [showAddAgentPanel, setShowAddAgentPanel] = useState(false)

    
    const providerValue = {
        agentListView, 
        setAgentListView,
        isTeamPresent, 
        setisTeamPresent,
        loggedInUserRole,
        loggedInUserName,
        teamSelected, setTeamSelected,
        isMarkException, setMarkException,
        agentsData, setAgentsData,
        showAddAgent, setShowAddAgent,
        agentsSelectedForMarking, setAgentsSelectedForMarking,
        isDateRangeExceeded, setIsDateRangeExceeded,
        selectedDate, setSelectedDate,
        showAttendanceCriteriaPanel, setShowAttendanceCriteriaPanel,
        showAddAgentPanel, setShowAddAgentPanel
    }

    return(
        <TeamManagementContext.Provider value={providerValue}>
            {props.children}
        </TeamManagementContext.Provider>
    )
}